export default {"src":"/_next/static/media/polygon.554d6d4a.svg","height":40,"width":40};